import { Trans } from '@lingui/react/macro';

import { useDirectVendorViewThrough } from '@/api/vendor';
import { SimpleSankeyDiagram } from '@/components/charts/SimpleSankeyDiagram';
import { Empty } from '@/components/Empty';
import { usePageFilterContext } from '@/components/page';
import { SupportLink } from '@/components/typography';

const DirectViewThroughAllocationWidget = () => {
  const {
    pageFilters: { startDate, endDate, audience },
  } = usePageFilterContext();
  const { viewThroughData, isOnlyDirectTraffic, isLoading, error } = useDirectVendorViewThrough(
    startDate,
    endDate,
    audience?.id,
  );

  const nodes = viewThroughData?.nodes;
  const links = viewThroughData?.links;

  if (isOnlyDirectTraffic) {
    return (
      <Empty>
        <Trans>
          Direct Reallocation is only possible through the use of Channel99 Pixels or Partner
          Integrations.
          <br />
          <SupportLink color="aqua" weight="regular" path="DIRECT_VIEW_THROUGH_REALLOCATION">
            Learn more
          </SupportLink>
        </Trans>
      </Empty>
    );
  }

  return (
    <SimpleSankeyDiagram
      error={error}
      isLoading={isLoading}
      nodes={nodes}
      links={links}
      emptyMessage={<Trans>No Direct Traffic Available</Trans>}
    />
  );
};

export default DirectViewThroughAllocationWidget;
